export const PDF_FILE_TYPE = 'pdf';
export const XLSX_FILE_TYPE = 'xlsx';
export const DOC_FILE_TYPE = 'doc';
export const DOCX_FILE_TYPE = 'docx';
export const PPT_FILE_TYPE = 'ppt';
export const PPTX_FILE_TYPE = 'pptx';
export const PNG_FILE_TYPE = 'png';
export const JPG_FILE_TYPE = 'jpg';
export const JPEG_FILE_TYPE = 'jpeg';
